import { Space, Tooltip } from 'antd';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SalesforceAutomation } from 'api/integrations';
import { User } from 'api/models';
import { Menu } from 'components/atoms/dropdown/menu';
import { MoreActionsDropdown } from 'components/atoms/more-actions';
import { Switch } from 'components/atoms/switch/switch';
import { getUserLabel } from 'utils/get-user-label';

type ColumnActions = {
  integrationId: string;
  handleEnable: (value: SalesforceAutomation) => void;
  handleDelete: (id: number) => void;
  handleEdit: (integraitonId: string, automationId: number) => void;
};

export const generateColumns = ({
  integrationId,
  handleEnable,
  handleEdit,
  handleDelete,
}: ColumnActions) => [
  {
    title: <FormattedMessage id="name" />,
    dataIndex: 'automationName',
    className: 'drag-visible',
  },
  {
    title: <FormattedMessage id="created_by" />,
    dataIndex: 'createdBy',
    width: 200,
    render: (createdBy: User) => getUserLabel(createdBy),
  },
  {
    title: <FormattedMessage id="last_modified" />,
    dataIndex: 'updatedAt',
    width: 200,
    render: (date) => moment(date).format('DD MMM YYYY h.mma'),
  },
  {
    title: <FormattedMessage id="status" />,
    dataIndex: 'enabled',
    width: 200,
    render: (status, row: SalesforceAutomation) => (
      <Space>
        <Switch
          onChange={(checked) => handleEnable({ ...row, enabled: checked })}
          checked={status}
          size="small"
        />
        {status ? (
          <FormattedMessage id="enabled" />
        ) : (
          <FormattedMessage id="disabled" />
        )}
      </Space>
    ),
  },
  {
    width: 40,
    render: (_, row) => {
      return (
        <Tooltip title="more actions">
          <MoreActionsDropdown
            className="more-actions"
            placement="bottomLeft"
            menu={
              <Menu>
                <Menu.ItemEdit
                  key="edit"
                  onClick={() => handleEdit(integrationId, row.automationId)}
                />
                <Menu.ItemDelete
                  key="delete"
                  onClick={() => handleDelete(row.automationId)}
                />
              </Menu>
            }
          />
        </Tooltip>
      );
    },
  },
];
